import React from "react";

const Settings = ({ isDarkMode, toggleDarkMode }) => {
  return (
    <div className="page-container">
      <h1>设置</h1>
      <div className="settings-item">
        <label>
          暗黑模式
          <input
            type="checkbox"
            checked={isDarkMode}
            onChange={toggleDarkMode}
          />
        </label>
      </div>
    </div>
  );
};

export default Settings;
